import '@/assets/styles/components/sign-up.styles.scss';
import { useState } from 'react';
import { Modal } from '@/components';
import { LoginModalProps } from './sign-up.types.ts';
import Forms from './forms';

export const SignUp = ({ isOpen, onClose }: LoginModalProps) => {
	const [activeForm, setActiveForm] = useState<string>('login');

	const handleFormChange = (form: string) => {
		setActiveForm(form);
	};

	const loginFormProps = {
		onClose,
		onFormChange: handleFormChange
	};

	const registerFormProps = {
		onClose,
		onFormChange: handleFormChange
	};

	const onCloseModal = (): void => {
		setActiveForm('login');
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onCloseModal}
			size="md"
			variant="centered"
			className="login-modal">
			{activeForm === 'login' ? <Forms.LoginForm {...loginFormProps} /> : <Forms.ForgetPasswordForm {...registerFormProps} />}
		</Modal>
	);
};
